import { render } from "./TextSidebarTreeNode.vue?vue&type=template&id=781aebae&scoped=true"
import script from "./TextSidebarTreeNode.vue?vue&type=script&lang=js"
export * from "./TextSidebarTreeNode.vue?vue&type=script&lang=js"

import "./TextSidebarTreeNode.vue?vue&type=style&index=0&id=781aebae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781aebae"]])

export default __exports__